const {SettingsManagement} = window.__GENERATED_CONSTANTS__

export const NotResetPasswordReason = {
    LAST_ADMIN_IN_ACTITIME: SettingsManagement.LAST_ADMIN_IN_ACTITIME,
    LAST_ADMIN_IN_ACTIPLANS: SettingsManagement.LAST_ADMIN_IN_ACTIPLANS,
}

export const ResetStatus = {
    Initial: "initial",
    Resetting: "resetting",
    ResettingAndSaving: "resettingAndSaving",
    ResetDone: "resetDone",
    ResetAndSaveDone: "resetAndSaveDone",

    isInProgress(status) {
        return status === ResetStatus.ResettingAndSaving || status === ResetStatus.Resetting
    }
};

export const SaveStatus = {
    Initial: "initial",
    Modified: "modified",
    Saved: "saved"
}



// WEBPACK FOOTER //
// ./web/js/administration/passwordSettings/common.js